<template>
  <v-tabs
    v-model="activeSection"
    align-tabs="end"
    :slider-size="1"
    :disabled="disabled"
    @update:model-value="onChange()"
  >
    <v-tab
      class="nav-item"
      v-for="filter in filters"
      :key="filter.value"
      :value="filter.value"
      :color="activeSection === filter.value ? 'primary' : 'grey'"
      :disabled="disabled"
    >
      {{ filter.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { FilterType } from '@/modules/contentCreator/creator/enums/FilterType'

export default {
  props: {
    section: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSection: this.section,
    }
  },
  computed: {
    filters() {
      return [
        { value: FilterType.ALL, label: this.$t('content-creator.tabs.all') },
        { value: FilterType.TODAY, label: this.$t('content-creator.tabs.today') },
        { value: FilterType.WEEK, label: this.$t('content-creator.tabs.this-week') },
        { value: FilterType.MONTH, label: this.$t('content-creator.tabs.this-month') },
        { value: FilterType.YEAR, label: new Date().getFullYear() },
      ]
    },
  },
  watch: {
    section(value) {
      this.activeSection = value
    },
  },
  methods: {
    onChange() {
      this.$emit('sectionChange', this.activeSection)
      this.$emit('refetch')
    },
  },
  emits: ['sectionChange', 'refetch'],
}
</script>
